import apiHandler from "../core/apiHandler";

const supplierApi = apiHandler('suppliers');
export default supplierApi;
